import { doc, getDoc, onSnapshot } from "firebase/firestore";
import { db } from "../../services/firebase";

const CARE_SOURCES_COLLECTION = "careSources";

export const getCareSourceById = async (sourceId = "") => {
  const cleanSourceId = String(sourceId || "").trim();
  if (!cleanSourceId) return null;

  const snapshot = await getDoc(
    doc(db, CARE_SOURCES_COLLECTION, cleanSourceId),
  );
  return snapshot.exists() ? { id: snapshot.id, ...snapshot.data() } : null;
};

export const subscribeCareSourceById = (sourceId, onSource, onError) =>
  onSnapshot(
    doc(db, CARE_SOURCES_COLLECTION, sourceId),
    (snapshot) =>
      onSource(
        snapshot.exists() ? { id: snapshot.id, ...snapshot.data() } : null,
      ),
    onError,
  );
